(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-blog"] && !Shopify.designMode) return;
  try {
      
document.querySelectorAll('[id^="shopify-section-"]').forEach((card, index) => {
   console.log = function(){};
   if(card.classList.contains('featured-blog')) {     
    const topHeading = card.querySelectorAll('.for-arrow-alignment');        
    const cardHeight = parseInt(topHeading[0].clientHeight);
    const topValue = cardHeight / 2 + 5;
    const cardTopCSS = "calc(50% - "+topValue+'px)';     
    const swiperContainer = card.querySelector('.swiper');    
     if(!swiperContainer) return;
    const swiperPrevElement = swiperContainer.querySelector('.swiper-button-prev');    
    const swiperNextElement = swiperContainer.querySelector('.swiper-button-next');     
    if(!swiperPrevElement || !swiperNextElement) return
    swiperPrevElement.setAttribute('style', 'top:'+cardTopCSS);    
    swiperNextElement.setAttribute('style', 'top:'+cardTopCSS);
  }        
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      // this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    // closeSearchModal() {
    //   this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    //   this.searchModal.close(false);
    // }
  }

  customElements.define('sticky-header', StickyHeader);
        
        
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));     
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);



  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            console.log(text);
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              $('.loading-image').removeClass('loading-image').addClass('loaded-image');
              let sameCard = document.querySelector('.from-recommended');
              let cardHeight = parseInt(sameCard.clientHeight);
              let topValue = cardHeight / 2 + 5;
              let cardTopCSS = "calc(50% - "+topValue+'px)';
              let swiperContainer = document.querySelector('.product-recommendations .swiper');
              let swiperPrevElement = swiperContainer.querySelector('.swiper-button-prev');
              let swiperNextElement = swiperContainer.querySelector('.swiper-button-next');
              swiperPrevElement.setAttribute('style', 'top:'+cardTopCSS);
              swiperNextElement.setAttribute('style', 'top:'+cardTopCSS);
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["starflex-dealer-controls"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.querySelector('[data-sf-dealer-controls]');
  if (!root) return;
  const status = root.querySelector('[data-status]');
  let started = false;
  const overview = () => {
    const map = window.Storemapper && window.Storemapper.map;
    if (!map || typeof map.fitBounds !== 'function') return false;
    map.fitBounds({ north: 65, south: 43, east: 22, west: -2 }, 30);
    return true;
  };
  const ready = () => {
    if (started || !overview()) return;
    started = true;
  };
  const previous = window.storemapper_callback;
  window.storemapper_callback = function (...args) {
    if (typeof previous === 'function') previous.apply(this, args);
    setTimeout(ready, 300);
  };
  let attempts = 0;
  const timer = setInterval(() => {
    ready();
    if (started || ++attempts >= 120) clearInterval(timer);
  }, 250);
  root.querySelector('[data-overview]').addEventListener('click', () => {
    window.location.reload();
  });
  root.querySelector('[data-location]').addEventListener('click', () => {
    if (!navigator.geolocation) { status.textContent = root.dataset.denied; return; }
    status.textContent = root.dataset.wait;
    navigator.geolocation.getCurrentPosition(position => {
      const input = document.querySelector('#storemapper-zip');
      const search = document.querySelector('#storemapper-go');
      if (!input || !search) { status.textContent = root.dataset.denied; return; }
      input.value = `${position.coords.latitude}, ${position.coords.longitude}`;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      search.click();
      status.textContent = root.dataset.ready;
    }, () => { status.textContent = root.dataset.denied; }, { timeout: 10000, maximumAge: 60000, enableHighAccuracy: false });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["starflex-facebook-recommendations"] && !Shopify.designMode) return;
  try {
    
  function initStarflexReviews(root) {
    root.querySelectorAll('.sf-facebook').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const grid = section.querySelector('.sf-facebook__grid');
      const controls = section.querySelector('.sf-facebook__controls');
      let offset = Math.floor(Math.random() * grid.children.length);
      try {
        const previous = sessionStorage.getItem('sf-customer-order');
        if (previous !== null) offset = (Number(previous) + 1) % grid.children.length;
        sessionStorage.setItem('sf-customer-order', String(offset));
      } catch (error) {}
      for (let i = 0; i < offset; i++) grid.append(grid.firstElementChild);
      const cards = Array.from(grid.children);
      const previous = controls.querySelector('[data-review-prev]');
      const next = controls.querySelector('[data-review-next]');
      const status = controls.querySelector('[data-review-status]');
      const desktop = window.matchMedia('(min-width: 990px)');
      const tablet = window.matchMedia('(min-width: 750px)');
      let page = 0;
      const draw = () => {
        const size = desktop.matches ? 4 : tablet.matches ? 2 : 1;
        const pages = Math.ceil(cards.length / size);
        page = Math.min(page, pages - 1);
        cards.forEach((card, index) => { card.hidden = index < page * size || index >= (page + 1) * size; });
        previous.disabled = page === 0;
        next.disabled = page === pages - 1;
        status.textContent = status.dataset.pattern.replace('[first]', page * size + 1).replace('[last]', Math.min((page + 1) * size, cards.length)).replace('[total]', cards.length);
        controls.hidden = pages < 2;
      };
      previous.addEventListener('click', () => { page--; draw(); });
      next.addEventListener('click', () => { page++; draw(); });
      controls.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' && !next.disabled) { event.preventDefault(); page++; draw(); }
        if (event.key === 'ArrowLeft' && !previous.disabled) { event.preventDefault(); page--; draw(); }
      });
      desktop.addEventListener('change', draw);
      tablet.addEventListener('change', draw);
      draw();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initStarflexReviews(document));
  else initStarflexReviews(document);
  document.addEventListener('shopify:section:load', event => initStarflexReviews(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["starflex-inspiration-rows"] && !Shopify.designMode) return;
  try {
    
function initStarflexStories() {
 document.querySelectorAll('.sf-story-list').forEach(section => {
  if (section.dataset.ready) return;
  section.dataset.ready = 'true';
  const track = section.querySelector('.sf-story-track');
  const prev = section.querySelector('[data-story-prev]');
  const next = section.querySelector('[data-story-next]');
  const update = () => { prev.disabled = track.scrollLeft < 2; next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2; };
  const move = direction => { const card = track.querySelector('.sf-story-row'); const gap = parseFloat(getComputedStyle(track).columnGap); track.scrollBy({left:direction * (card.offsetWidth + gap), behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'}); };
  prev.addEventListener('click', () => move(-1));
  next.addEventListener('click', () => move(1));
  track.addEventListener('scroll',update,{passive:true});
  window.addEventListener('resize',update);
  update();
 });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initStarflexStories); else initStarflexStories();
document.addEventListener('shopify:section:load',initStarflexStories);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["starflex-open-map"] && !Shopify.designMode) return;
  try {
    
(function(){
 function setup(root){
  if(root.dataset.ready)return;root.dataset.ready='true';
  const data=JSON.parse(root.querySelector('[data-dealers]').textContent),copy=JSON.parse(root.querySelector('[data-copy]').textContent),list=root.querySelector('ol'),status=root.querySelector('[data-status]'),search=root.querySelector('[data-search]');
  let map,markers=[],origin=null;
  const norm=s=>s.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'');
  const names={'Norway':'Norge Norway','Sweden':'Sverige Sweden','France':'Frankrike France','Germany':'Tyskland Germany Deutschland','Poland':'Polen Poland','Slovakia':'Slovakia Slovensko','Switzerland':'Sveits Switzerland','United Kingdom':'Storbritannia England UK United Kingdom'};
  const distance=d=>{let a=origin.latitude*Math.PI/180,b=d.lat*Math.PI/180,x=(d.lat-origin.latitude)*Math.PI/180,y=(d.lon-origin.longitude)*Math.PI/180;return 6371*2*Math.atan2(Math.sqrt(Math.sin(x/2)**2+Math.cos(a)*Math.cos(b)*Math.sin(y/2)**2),Math.sqrt(1-(Math.sin(x/2)**2+Math.cos(a)*Math.cos(b)*Math.sin(y/2)**2)));};
  const link=d=>{const a=document.createElement('a');a.href='https://www.openstreetmap.org/directions?to='+encodeURIComponent(d.lat+','+d.lon);a.target='_blank';a.rel='noopener';a.textContent=copy.directions;return a;};
  function contacts(d){const p=document.createElement('p');p.className='sf-map-contacts';if(d.phone){const a=document.createElement('a');a.href='tel:'+d.phone.replace(/[^+0-9]/g,'');a.textContent=d.phone;p.append(a);}if(d.website){const a=document.createElement('a');a.href=d.website;a.target='_blank';a.rel='noopener';a.textContent=copy.website;p.append(a);}return p;}
  function render(){
   const q=norm(search.value.trim()),result=data.map((d,i)=>({...d,i})).filter(d=>norm(d.name+' '+d.address+' '+Object.entries(names).filter(([k])=>d.address.includes(k)).map(([,v])=>v).join(' ')).includes(q));
   if(origin)result.sort((a,b)=>distance(a)-distance(b));
   list.replaceChildren();result.forEach(d=>{const li=document.createElement('li'),h=document.createElement('h2'),p=document.createElement('p'),b=document.createElement('button');h.textContent=d.name;p.textContent=d.address+(origin?' · '+Math.round(distance(d))+' km':'');b.type='button';b.textContent=copy.show;b.addEventListener('click',()=>{if(map){map.setView([d.lat,d.lon],d.approximate?13:15);markers[d.i].openPopup();root.querySelector('.sf-ownmap-canvas').scrollIntoView({behavior:'smooth',block:'center'});}});li.append(h,p,contacts(d),b,link(d));if(d.approximate){const s=document.createElement('small');s.textContent=copy.approx;li.append(s);}list.append(li);});
   status.textContent=data.length+' '+copy.markers;root.dataset.visibleResults=result.length;
  }
  render();search.addEventListener('input',render);
  root.querySelector('[data-all]').addEventListener('click',()=>{search.value='';origin=null;render();if(map)map.fitBounds(data.map(d=>[d.lat,d.lon]),{padding:[35,35]});});
  root.querySelector('[data-near]').addEventListener('click',()=>{if(!navigator.geolocation){status.textContent=copy.denied;return;}status.textContent=copy.locating;navigator.geolocation.getCurrentPosition(p=>{origin={latitude:p.coords.latitude,longitude:p.coords.longitude};search.value='';render();status.textContent=copy.sorted+' · '+data.length+' '+copy.markers;},()=>{render();status.textContent=copy.denied+' · '+data.length+' '+copy.markers;},{enableHighAccuracy:false,timeout:10000,maximumAge:300000});});
  function init(){if(!window.L){status.textContent=copy.failed;return;}map=L.map(root.querySelector('.sf-ownmap-canvas'),{scrollWheelZoom:false,minZoom:2,maxZoom:18,dragging:!matchMedia('(pointer:coarse)').matches,touchZoom:true});L.tileLayer(root.dataset.tiles,{maxZoom:19,attribution:'&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'}).addTo(map);data.forEach((d,i)=>{const box=document.createElement('div'),h=document.createElement('strong'),p=document.createElement('p');h.textContent=d.name;p.textContent=d.address;box.append(h,p,contacts(d),link(d));if(d.approximate){const n=document.createElement('p');n.textContent=copy.approx;box.append(n);}markers.push(L.marker([d.lat,d.lon],{title:d.name,alt:d.name,icon:L.divIcon({className:'sf-map-pin',html:'',iconSize:[16,16],iconAnchor:[8,8]})}).addTo(map).bindPopup(box));});map.fitBounds(data.map(d=>[d.lat,d.lon]),{padding:[35,35]});root.dataset.markerCount=markers.length;new ResizeObserver(()=>map.invalidateSize()).observe(root.querySelector('.sf-ownmap-canvas'));render();}
  if(document.readyState==='complete')init();else window.addEventListener('load',init,{once:true});
 }
 document.querySelectorAll('[data-sf-ownmap]').forEach(setup);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-sf-ownmap]').forEach(setup));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["starflex-product-details"]) return;
  try {
    
(() => {
  function initializeTabs() {
    document.querySelectorAll('[data-sf-product-tabs]').forEach(root => {
      if (root.dataset.ready) return;
      const info = document.querySelector('#MainContent .product__info-container');
      const description = info && info.querySelector('[data-sf-description]');
      const originalDescription = description && description.closest('.product__accordion');
      if (!originalDescription) return;
      const wrapper = root.parentElement;
      const reviews = info.querySelector('[data-sf-reviews]');
      const originalReviews = reviews && reviews.closest('.product__accordion');
      const panels = Array.from(root.querySelectorAll('[data-sf-panel]'));
      const buttons = Array.from(root.querySelectorAll('[data-sf-tab]'));
      const nav = root.querySelector('.sf-product-tabs__nav');
      originalDescription.before(root);
      // The following replacement is confined to the unpublished review fixture.
      const bodyReview = root.querySelector('[data-sf-body-review-fixture]');
      if (bodyReview) {
        description.replaceChildren(bodyReview.content.cloneNode(true));
        root.dataset.bodyReviewFixture = bodyReview.dataset.reviewLocale;
        const reviewedHeading = document.querySelector('main h1');
        if (reviewedHeading && bodyReview.dataset.reviewTitle) reviewedHeading.textContent = bodyReview.dataset.reviewTitle;
        bodyReview.remove();
      }
      panels[0].append(description);
      originalDescription.hidden = true;
      if (reviews) {
        panels[3].append(reviews);
        if (originalReviews) originalReviews.hidden = true;
        const updateReviewStatus = () => {
          const hasContent = reviews.textContent.trim().length > 0 || !!reviews.querySelector('iframe');
          root.querySelector('[data-sf-review-empty]').hidden = hasContent;
        };
        updateReviewStatus();
        new MutationObserver(updateReviewStatus).observe(reviews, {childList: true, subtree: true, characterData: true});
      }
      root.querySelectorAll('.sf-product-tabs__specs p').forEach(p => {
        const list = document.createElement('ul');
        p.textContent.split(';').map(t => t.trim()).filter(Boolean).forEach(text => {
          const item = document.createElement('li'); item.textContent = text; list.append(item);
        });
        p.replaceWith(list);
      });
      root.querySelectorAll('.sf-product-tabs__specs ul').forEach(list => {
        const table = document.createElement('table'); table.className = 'sf-specs-table';
        const body = document.createElement('tbody');
        Array.from(list.children).forEach(item => {
          const row = document.createElement('tr'), text = item.textContent.trim(), split = text.indexOf(':');
          if (split > 0) {
            const label = document.createElement('th'), value = document.createElement('td');
            label.scope = 'row'; label.textContent = text.slice(0, split); value.textContent = text.slice(split + 1).trim(); row.append(label, value);
          } else { const value = document.createElement('td'); value.colSpan = 2; value.textContent = text; row.append(value); }
          body.append(row);
        });
        table.append(body); list.replaceWith(table);
      });
      function activate(index, focus) {
        buttons.forEach((button, i) => {
          button.setAttribute('aria-selected', String(i === index)); button.tabIndex = i === index ? 0 : -1;
          panels[i].hidden = i !== index;
        });
        if (focus) buttons[index].focus();
      }
      nav.setAttribute('role', 'tablist'); nav.setAttribute('aria-label', root.getAttribute('aria-label'));
      buttons.forEach((button, i) => {
        button.setAttribute('role', 'tab');
        panels[i].setAttribute('role', 'tabpanel'); panels[i].setAttribute('aria-labelledby', button.id); panels[i].tabIndex = 0;
        button.addEventListener('click', () => activate(i, false));
        button.addEventListener('keydown', event => {
          let target;
          if (event.key === 'ArrowRight') target = (i + 1) % buttons.length;
          if (event.key === 'ArrowLeft') target = (i + buttons.length - 1) % buttons.length;
          if (event.key === 'Home') target = 0;
          if (event.key === 'End') target = buttons.length - 1;
          if (target !== undefined) { event.preventDefault(); activate(target, true); }
        });
      });
      root.dataset.ready = 'true'; nav.hidden = false; activate(0, false);
      if (wrapper && wrapper.classList.contains('shopify-section')) wrapper.hidden = true;
      // Legacy QR hashes all lead to the current guide in the Description panel.
      // Resolve after the panel is mounted, rather than scrolling to the old body.
      let qrLandingVersion = 0;
      let qrLandingInterrupted = false;
      const stopQrLanding = () => { qrLandingInterrupted = true; qrLandingVersion += 1; };
      ['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach(type => {
        window.addEventListener(type, stopQrLanding, {passive: true});
      });
      function revealQrGuide() {
        if (!/^#starflex-qr-(guide|no|en|de|fr)$/.test(window.location.hash)) return;
        qrLandingInterrupted = false;
        const version = ++qrLandingVersion;
        activate(0, false);
        const landOnCurrentGuide = () => {
          if (qrLandingInterrupted || version !== qrLandingVersion) return;
          const guideLink = Array.from(panels[0].querySelectorAll('a[href]')).find(link => {
            return /\/pages\/tips-og-inspirasjon(?:[?#]|$)/.test(link.getAttribute('href'));
          });
          const alias = Array.from(panels[0].querySelectorAll('[id]')).find(element => {
            return '#' + element.id === window.location.hash;
          });
          const target = guideLink || alias;
          if (target) target.scrollIntoView({block: 'center', behavior: 'instant'});
        };
        requestAnimationFrame(() => requestAnimationFrame(landOnCurrentGuide));
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(landOnCurrentGuide);
        if (document.readyState !== 'complete') {
          window.addEventListener('load', landOnCurrentGuide, {once: true});
        }
      }
      window.addEventListener('hashchange', revealQrGuide);
      revealQrGuide();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeTabs); else initializeTabs();
  document.addEventListener('shopify:section:load', initializeTabs);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["starflex-product-filter"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('starflex-product-filter'))customElements.define('starflex-product-filter',class extends HTMLElement{
connectedCallback(){
 if(this.dataset.ready)return;this.dataset.ready='true';
 const cards=[...this.querySelectorAll('[data-groups]')],grid=this.querySelector('.sf-filter__grid'),checks=[...this.querySelectorAll('input[name="need"]')],sort=this.querySelector('[name="sort"]'),label=this.querySelector('[data-count-label]').textContent;
 if(Number(this.querySelector('[data-total]').textContent)>cards.length){this.querySelector('.sf-filter__panel').hidden=true;this.querySelector('[data-result]').textContent=cards.length+' / '+this.querySelector('[data-total]').textContent+' '+label;return;}
 checks.forEach(c=>{this.querySelector('[data-count="'+c.value+'"]').textContent='('+cards.filter(x=>x.dataset.groups.split(' ').includes(c.value)).length+')';});
 const apply=()=>{const selected=checks.filter(c=>c.checked).map(c=>c.value),availability=[...this.querySelectorAll('[name=availability]:checked')].map(c=>c.value);let count=0;
 cards.sort((a,b)=>{switch(sort.value){case 'price-ascending':return Number(a.dataset.price)-Number(b.dataset.price);case 'price-descending':return Number(b.dataset.price)-Number(a.dataset.price);case 'title-ascending':return a.dataset.title.localeCompare(b.dataset.title);case 'title-descending':return b.dataset.title.localeCompare(a.dataset.title);default:return Number(a.dataset.index)-Number(b.dataset.index);}}).forEach(card=>{card.hidden=(selected.length>0&&!selected.some(id=>card.dataset.groups.split(' ').includes(id)))||(availability.length>0&&!availability.includes(card.dataset.available));if(!card.hidden)count++;grid.append(card);});this.querySelector('[data-result]').textContent=count+' '+label;this.querySelector('[data-empty]').hidden=count!==0;};
 this.addEventListener('change',apply);this.addEventListener('input',e=>{if(e.target.type==='number')apply();});this.querySelector('[data-reset]').addEventListener('click',()=>{this.querySelectorAll('input[type=checkbox]').forEach(c=>c.checked=false);this.querySelectorAll('input[type=number]').forEach(c=>c.value='');sort.selectedIndex=0;apply();});apply();
}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["starflex-showcase"] && !Shopify.designMode) return;
  try {
    
function initStarflexShowcase(root){
 root.querySelectorAll('.sf-showcase').forEach(section=>{
  if(section.dataset.ready)return; section.dataset.ready='true';
  const slides=Array.from(section.querySelectorAll('.sf-showcase__slide'));
  const status=section.querySelector('[data-showcase-status]');
  if(!status)return;
  let index=0;
  const draw=()=>{slides.forEach((slide,i)=>{slide.hidden=i!==index});status.textContent=`${index+1} / ${slides.length}`};
  section.querySelector('[data-showcase-prev]').addEventListener('click',()=>{index=(index+slides.length-1)%slides.length;draw()});
  section.querySelector('[data-showcase-next]').addEventListener('click',()=>{index=(index+1)%slides.length;draw()});
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initStarflexShowcase(document));else initStarflexShowcase(document);
document.addEventListener('shopify:section:load',event=>initStarflexShowcase(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-gallery"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll('[data-video-filter]').forEach(filter => {
    const categories = Array.from(filter.closest('.video-gallery-section').querySelectorAll('[data-video-category]'), card => card.dataset.videoCategory);
    Array.from(filter.options).forEach(option => { if (option.value !== 'all' && !categories.includes(option.value)) option.remove(); });
    filter.addEventListener('change', () => {
      const section = filter.closest('.video-gallery-section');
      section.querySelectorAll('[data-video-category]').forEach(card => {
        card.classList.remove('hidden-video');
        card.hidden = filter.value !== 'all' && card.dataset.videoCategory !== filter.value;
      });
      const button = section.querySelector('.load-more-btn');
      if (button) button.hidden = true;
    });
  });
  // Load more videos
  const loadBtn = document.getElementById("loadMoreVideos");
  if(loadBtn){
    loadBtn.addEventListener("click", function(){
      document.querySelectorAll(".hidden-video").forEach(v => v.classList.remove("hidden-video"));
      loadBtn.style.display = "none";
    });
  }

  // Play video on click
  document.querySelectorAll(".video-gallery-section .video-wrapper").forEach(wrapper => {
    const play = function(){
      const url = wrapper.getAttribute("data-video-url");
      let iframe = document.createElement("iframe");
      iframe.setAttribute("frameborder", "0");
      iframe.setAttribute("allowfullscreen", "true");
      iframe.setAttribute("allow", "autoplay; fullscreen; picture-in-picture");

      if(url.includes("vimeo.com")){
        const video_id = url.split("/").pop();
        iframe.src = "https://player.vimeo.com/video/" + video_id + "?autoplay=1";
      } else if(url.includes("youtube.com") || url.includes("youtu.be")){
        let video_id = "";
        if(url.includes("youtube.com")){
          video_id = url.split("v=").pop().split("&")[0];
        } else if(url.includes("youtu.be")){
          video_id = url.split("/").pop();
        }
        iframe.src = "https://www.youtube.com/embed/" + video_id + "?rel=0&modestbranding=1&showinfo=0&autoplay=1&controls=1";
      }

      iframe.title = wrapper.getAttribute('aria-label');
      wrapper.innerHTML = "";
      wrapper.removeAttribute('role');
      wrapper.removeAttribute('tabindex');
      wrapper.appendChild(iframe);
    };
    wrapper.addEventListener('click', play, { once: true });
    wrapper.addEventListener('keydown', function(event) {
      if ((event.key === 'Enter' || event.key === ' ') && !wrapper.querySelector('iframe')) { event.preventDefault(); play(); }
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
